import { Button, DialogActions, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { Form, Formik } from 'formik';
import FormTextField from '../../../components/FormTextField';
import { buttonStyle2 } from '../../../utils/commonStyle';
import * as yup from 'yup';
import { useRef } from 'react';
import { useTheme } from '@emotion/react';
import EditOrganization from './Components/EditOrganization';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../../redux/features/appSlice';
import appapi from '../../../api/apiClient';
import { showmessage } from '../../../utils/toastr';

const validationSchema = yup.object({
  oldPassword: yup.string().required('Password is required').matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/, 'Enter a password of minimum 8 and maximum 20 characters with a combination of capital letters, small letters, symbols, and numbers.'),
  newPassword: yup.string().required('Password is required').matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/, 'Enter a password of minimum 8 and maximum 20 characters with a combination of capital letters, small letters, symbols, and numbers.'),
  confirmPassword: yup.string()
    .oneOf([yup.ref('newPassword'), null], 'Passwords must match').required().trim()
});

export default function SettingsPage() {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();

  const { userId, companyDetails } = useSelector((state) => state.auth);

  const [visibility1, setVisibility1] = useState(false);
  const [visibility2, setVisibility2] = useState(false);
  const [visibility3, setVisibility3] = useState(false);

  const [openEditOrganization, setOpenEditOrganization] = useState(false);

  const reset = async (obj) => {
    dispatch(setLoading(true));
    let payload = {
      userId,
      ...obj
    };
    const response = await appapi.put(`user/changePassword`, payload);
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        formRef.current?.resetForm({ oldPassword: '',
        newPassword: '',
        confirmPassword: ''});

        showmessage(data.message, 'success');

      } else {
        showmessage(data.message, 'error');
      }
      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(false));
      // showmessage(`Something Went Wrong!`, 2000, 'error')
    }
  };

  return (
    <Stack
      flex={1}
      style={{ backgroundColor: '#F7F7F7', padding: '8px', height: '100%' }}
    >
      <Stack
        style={{ backgroundColor: '#FFFFFF', borderRadius: '8px' }}
        flex={1}
      >
        <Stack className="p-[16px]">
          <Typography
            className="fw-medium fs-16 ff-Roboto"
            color={'#14285A'}
          >
            SETTINGS
          </Typography>
        </Stack>

        <Stack style={{ backgroundColor: '#F2F2F2', height: '1px', width: '100%' }} />
        <Stack
          direction={'row'}
          //   alignItems={'center'}
          flex={1}
          style={{ height: '100%', marginTop: '10px' }}
        >
          <Stack flex={0.5}>
            <Stack
              direction={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
              className="p-[16px]"
            >
              <Typography
                className="fw-medium fs-16 ff-Roboto"
                color={'#14285A'}
              >
                ORGANISATION DETAIL
              </Typography>
              <Tooltip
                disableInteractive
                title="Edit Details"
              >
                <IconButton onClick={() => setOpenEditOrganization(true)}>
                  <EditIcon style={{ transform: 'scale(1.143)', color: '#061D30', width: '18px', height: '18px' }} />
                </IconButton>
              </Tooltip>
            </Stack>
            <Stack className="px-[16px]">
              <Stack>
                <Typography
                  className="fw-regular fs-12 ff-Roboto"
                  color={'#14285A'}
                >
                  Company Name
                </Typography>
                <Typography
                  className="fw-medium fs-14 ff-Roboto mt-[5px]"
                  color={'#14285A'}
                >
                  {companyDetails?.companyName}
                </Typography>
              </Stack>
              <Stack className="mt-[24px]">
                <Typography
                  className="fw-regular fs-12 ff-Roboto"
                  color={'#14285A'}
                >
                  Address
                </Typography>
                <Typography
                  className="fw-medium fs-14 ff-Roboto mt-[5px]"
                  color={'#14285A'}
                >
                  {companyDetails?.regAddress}
                </Typography>
              </Stack>
              <Stack className="mt-[24px]">
                <Typography
                  className="fw-regular fs-12 ff-Roboto "
                  color={'#14285A'}
                >
                  State/Country
                </Typography>
                <Typography
                  className="fw-medium fs-14 ff-Roboto mt-[5px] capitalize"
                  color={'#14285A'}
                >
                  {companyDetails?.stateName}, {companyDetails?.countryName}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
          <Stack style={{ backgroundColor: '#F2F2F2', height: '100%', width: '1px' }} />
          <Stack flex={0.5}>
            <Stack className="mt-[21px] px-[16px]">
              <Typography
                className="fw-medium fs-16 ff-Roboto"
                color={'#14285A'}
              >
                CHANGE PASSWORD
              </Typography>
            </Stack>
            <Stack className="mt-[24px]">
              <Formik
                innerRef={formRef}
                enableReinitialize={false}
                initialValues={{ oldPassword: '',
                newPassword: '',
                confirmPassword: ''}}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                  reset(values);
                 }}
              >
                {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue }) => (
                  <Form autoComplete="off">
                    <Stack
                      style={{ backgroundColor: 'white', borderRadius: '8px' }}
                      className="px-[16px]"
                    >
                      <Stack>
                        <FormTextField
                          placeholder={'Enter Old password'}
                          outlineLabel={'Enter Old password'}
                          name="oldPassword"
                          requiredMark={true}
                          whiteSpace={true}
                          type="password"
                          visibility={visibility1}
                          setVisibility={(val) => setVisibility1(val)}
                        />
                      </Stack>
                      <Stack>
                        <FormTextField
                          placeholder={'Enter New Password'}
                          outlineLabel={'Enter New Password'}
                          name="newPassword"
                          requiredMark={true}
                          type="password"
                          visibility={visibility2}
                          setVisibility={(val) => setVisibility2(val)}
                        />
                      </Stack>
                      <Stack>
                        <FormTextField
                          placeholder={'Confirm Password'}
                          outlineLabel={'Confirm Password'}
                          name="confirmPassword"
                          requiredMark={true}
                          whiteSpace={true}
                          type="password"
                          visibility={visibility3}
                          setVisibility={(val) => setVisibility3(val)}
                        />
                      </Stack>
                    </Stack>

                    <Stack style={{ backgroundColor: '#F2F2F2', height: '1px', width: '100%', marginTop: '255px' }} />
                    <DialogActions
                      className="!mt-[250px] h-[66px] !justify-end p-[0px] sticky bottom-[0]"
                      style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
                    >
                      <Button
                        sx={[
                          buttonStyle2,
                          {
                            color: theme.palette.background.main,
                            backgroundColor: theme.palette.primary.dark,
                            '&:hover': {
                              // backgroundColor: theme.palette.secondary.main,
                              // color: theme.palette.background.main,
                            },
                          },
                        ]}
                        style={{ width: '128px', height: '40px' }}
                        disabled={!(dirty && isValid)}
                        type="submit"
                        variant="contained"
                      >
                        SAVE
                      </Button>
                    </DialogActions>
                  </Form>
                )}
              </Formik>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      {openEditOrganization ? (
        <EditOrganization
          companyDetails={companyDetails}
          onModelHandleClose={(event) => {
            if (event) {
              //   setPayload((prev) => ({ ...prev, page: 1 }));
              //   getCompanyList();
            }
            setOpenEditOrganization(false);
          }}
          modelOpen={openEditOrganization}
        />
      ) : null}
    </Stack>
  );
}
